export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const heroAssets = {
  poster: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/707912a5-b957-4856-9aff-f6b5b202ad01_hero-poster.webp',
  video: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/707912a5-b957-4856-9aff-f6b5b202ad01_hero-video.mp4',
};

export const services = [
  {
    title: 'Recurring Home Cleaning',
    text: 'Keep your home feeling fresh, week after week.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-svc-01.webp',
  },
  {
    title: 'Deep Cleaning',
    text: 'Extra attention for the spaces that need it most.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-svc-02.webp',
  },
  {
    title: 'Move-In / Move-Out Cleaning',
    text: 'A cleaner beginning for your next chapter.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-svc-03.webp',
  },
];

export const whyImage = 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-why.webp';

export const benefits = [
  { icon: 'ri-sparkling-2-line', title: 'Thoughtful Cleaning Methods', text: 'A considered approach for each room, from surfaces to the corners that are easy to miss.' },
  { icon: 'ri-user-heart-line', title: 'Attentive Professionals', text: 'A respectful team that treats your home with care and pays attention to how you like things done.' },
  { icon: 'ri-calendar-check-line', title: 'Flexible Service Options', text: 'Weekly, bi-weekly, monthly or one-time — choose the rhythm that fits your life.' },
  { icon: 'ri-chat-smile-2-line', title: 'Clear, Simple Communication', text: 'Straightforward plans and easy updates, so you always know what to expect.' },
];

export const steps = [
  { num: '01', title: 'Tell Us What You Need', text: 'Share your space and service preferences.' },
  { num: '02', title: 'Plan Your Cleaning', text: 'Request a preferred date and receive a service plan.' },
  { num: '03', title: 'Enjoy a Fresh Start', text: 'Let the team focus on the details.' },
];

export const faqs = [
  { q: "What's included in a standard cleaning?", a: 'A standard cleaning typically covers dusting reachable surfaces, wiping kitchen counters and exteriors of appliances, cleaning bathrooms, vacuuming and mopping floors, and emptying bins. Exact tasks are confirmed in your service plan.' },
  { q: 'Do I need to provide supplies?', a: 'Let us know your preference when you request a quote. Supplies and any product preferences can be discussed and confirmed before your first visit.' },
  { q: 'Can I request a one-time deep clean?', a: 'Yes. You can request a one-time deep clean on its own, or as a starting point before recurring service.' },
  { q: 'How can I request a quote?', a: 'Fill out the quote form on this page with a few details about your home and the service you are interested in. We will follow up to discuss the next steps.' },
  { q: 'What should I do before the team arrives?', a: 'It helps to put away personal items and valuables, secure pets, and note any areas that need special attention or should be avoided.' },
];

export const serviceOptions = ['Recurring Home Cleaning', 'Deep Cleaning', 'Move-In / Move-Out Cleaning', 'Not sure yet'];
export const homeSizes = ['Apartment — Studio / 1 bedroom', 'Apartment — 2+ bedrooms', 'House — up to 3 bedrooms', 'House — 4+ bedrooms', 'Other'];